import React from "react";
import {
  MainContainer,
  Text,
  Dot,
  DotContainer,
  DotLabel,
  ImageContainer,
  InfoContainer,
} from "./TimelineItem.styles";

const TimelineItem = ({ date, text, image }) => {
  return (
    <MainContainer>
      <DotContainer>
        <Dot />
        <DotLabel>{date}</DotLabel>
      </DotContainer>
      <InfoContainer>
        <ImageContainer>{image}</ImageContainer>
        <Text>{text}</Text>
      </InfoContainer>
    </MainContainer>
  );
};

export default TimelineItem;
